import React from 'react';
import clsx from 'clsx';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from 'pages/Dashboard/components/Input/Checkbox';
import isArray from 'lodash/isArray';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';
import {
  getStableKey,
} from 'views/EMR/components/FillableForm/utils/fieldPositioning';

function getSelectedChildIds(formDynamicField: FieldComponentProps['value']): string[] {
  if (!isArray(formDynamicField?.value)) {
    return [];
  }

  return formDynamicField.value.filter((childId): childId is string => typeof childId === 'string');
}

export default function CheckboxGroupField({
  field,
  value,
  onChange,
  error = false,
}: FieldComponentProps) {
  const selectedChildIds = getSelectedChildIds(value);

  function handleToggle(childId: string) {
    const nextSelectedChildIds = selectedChildIds.includes(childId)
      ? selectedChildIds.filter((selectedChildId) => selectedChildId !== childId)
      : [...selectedChildIds, childId];

    onChange?.({ ...value, value: nextSelectedChildIds });
  }

  return (
    <div className="w-full min-w-0">
      <FormControl className="w-full">
        <FormGroup className="!flex-row flex-wrap gap-x-4 gap-y-1 w-full">
          {field?.children?.map((child) => (
            <FormControlLabel
              key={getStableKey(child, field.id)}
              className={clsx('!ml-0 whitespace-nowrap', { '!text-red-500': error })}
              classes={{
                label: clsx('text-sm', { '!text-red-500': error }),
              }}
              label={child?.name}
              control={(
                <Checkbox
                  id={child?.id ?? `checkbox-group-option-${getStableKey(child, field.id)}`}
                  checked={selectedChildIds.includes(child?.id ?? '')}
                  onChange={() => {
                    handleToggle(child?.id ?? '');
                  }}
                  classes={{
                    root: clsx({ '!text-red-500': error }),
                  }}
                />
              )}
            />
          ))}
        </FormGroup>
      </FormControl>
    </div>
  );
}
